import(/* webpackMode: "eager" */ "/app/src/app/[locale]/blog/page.tsx");
